export const formatMillions = (num) => {
	if (typeof num !== "number" || isNaN(num)) return ""
	if (num < 1_000_000) return num.toString()

	const millions = num / 1_000_000;
	return `${millions.toFixed(1).replace('.', ',')} млн`
}